'use strict'

// --- tiny fetch helpers reused below ---
function csrfToken() {
    const el = document.querySelector('meta[name="csrf-token"]')
    return el ? el.getAttribute('content') : ''
}
async function handleJSON(res) {
    if (!res.ok) {
        let message = `HTTP ${res.status}`
        const ct = res.headers.get('Content-Type') || ''
        if (ct.includes('application/json')) {
            try {
                message = (await res.json())?.message || message
            } catch {}
        } else {
            try {
                const t = await res.text()
                if (t) message = t
            } catch {}
        }
        const err = new Error(message)
        err.status = res.status
        throw err
    }
    if (res.status === 204) return null
    return res.json()
}
function postJSON(url, body) {
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': csrfToken(),
        },
        credentials: 'same-origin',
        body: JSON.stringify(body),
    }).then(handleJSON)
}

const ProjectAPI = {
    // Fixed endpoints (relative to current subdomain/host)
    ROUTES: {
        image: '/projects/store-from-image',
        exchange: '/projects/store-from-exchange-file',
    },

    /** Return correct upload route for a given kind ('image' | 'project' | 'exchange'). */
    getUploadRoute(kind) {
        if (kind === 'image') return this.ROUTES.image
        // treat both 'project' and 'exchange' as the same endpoint
        if (kind === 'project' || kind === 'exchange') return this.ROUTES.exchange
        throw new Error(`Unknown upload kind: ${kind}`)
    },

    /** Create a project from a prepaint photo + colorsample. */
    storeFromPrepaintPhoto({ prepaint_photo_id, color_sample_id }) {
        return postJSON('/projects/store-from-prepaint-photo', {
            prepaint_photo_id: Number(prepaint_photo_id),
            color_sample_id: Number(color_sample_id),
        })
    },
}

window.ProjectAPI = ProjectAPI
export default ProjectAPI
